import React, { useState } from "react";

const InvoiceReport = () => {
  const defaultReportData = {
    Header: { InvoiceNo: "KK/25-26/000203", InvoiceDate: "25-Apr-2025" },
    Buyer: {
      Name: "SUPER INDIA PAPER PVT LTD-DELHI",
      Address: "SHOP 4863 BARA HINDU RAO PHARI DHIRAJ DELHI DELHI DELHI INDIA-110006",
      GSTIN: "07AABCS2209P1Z7",
      State: "DELHI",
      Code: "07",
    },
    Consignee: {
      Name: "SUPER INDIA PAPER PVT LTD-MUNDAKA",
      Address: "ΚΗ ΝΟ-40/21 MUNDAKA NORTH WEST NEAR SURYANATH DHARAM KΑΝΤΑ . DELHI DELHI INDIA-110041",
      GSTIN: "07AABCS2209P1Z7",
      State: "DELHI",
      Code: "07",
    },
    Items: [
      {
        quality: "IRIS",
        gsm: "200",
        size: "27 x 30.50",
        hsn: "48109900",
        orderNo: "AP-124-2025",
        qty: 37,
        uom: "KG",
        totalWeight: 2218.50,
        unitPrice: 37.50,
        totalValue: 83193.75,
      },
      {
        quality: "IRIS",
        gsm: "200",
        size: "32 x 28",
        hsn: "48109900",
        orderNo: "AP-145-2025",
        qty: 48,
        uom: "KG",
        totalWeight: 3154.00,
        unitPrice: 37.50,
        totalValue: 118275.00,
      },
      {
        quality: "IRIS",
        gsm: "230",
        size: "25 x 38",
        hsn: "48109900",
        orderNo: "AP-107-2025",
        qty: 35,
        uom: "KG",
        totalWeight: 2111.20,
        unitPrice: 35.50,
        totalValue: 74947.60,
      },
      {
        quality: "IRIS",
        gsm: "230",
        size: "26 x 32",
        hsn: "48109900",
        orderNo: "AP-107-2025",
        qty: 45,
        uom: "KG",
        totalWeight: 2367.40,
        unitPrice: 35.50,
        totalValue: 84042.70,
      },
      {
        quality: "IRIS",
        gsm: "230",
        size: "26 x 36",
        hsn: "48109900",
        orderNo: "AP-107-2025",
        qty: 38,
        uom: "KG",
        totalWeight: 2240.00,
        unitPrice: 35.50,
        totalValue: 79520.00,
      },
      {
        quality: "IRIS",
        gsm: "230",
        size: "28 x 35",
        hsn: "48109900",
        orderNo: "AP-107-2025",
        qty: 33,
        uom: "KG",
        totalWeight: 2048.20,
        unitPrice: 35.50,
        totalValue: 72711.10,
      },
      {
        quality: "IRIS",
        gsm: "230",
        size: "34 x 29",
        hsn: "48109900",
        orderNo: "AP-125-2025",
        qty: 26,
        uom: "KG",
        totalWeight: 1603.60,
        unitPrice: 35.50,
        totalValue: 56927.80,
      },
      {
        quality: "IRIS",
        gsm: "230",
        size: "40 x 28",
        hsn: "48109900",
        orderNo: "AP-125-2025",
        qty: 35,
        uom: "KG",
        totalWeight: 1673.00,
        unitPrice: 35.50,
        totalValue: 59391.50,
      },
    ],
    TotalReels: 297,
    TotalWeight: 17415.90,
    TotalValue: 629009.45,
    Summary: {
      AssessableValue: 641327.69,
      TaxAmount: 76959.32,
      Freight: 12190.00,
      Insurance: 128.24,
      Discount: 0,
      NetAmount: 718287.00,
      AmountInWords: "Seven Lakhs Eighteen Thousand Two Hundred and Eighty Seven Rupees Only",
      RoundOff: -0.01
    },
    Transport: { Name: "A-ONE ROADWAYS", VehicleNo: "HR38AD9477", ShipmentMode: "Road", LRNo: "970", TermsOfPayment: "Immediate from Invoice Date", DueDate: "25-Apr-2025" },
    Bank: { Name: "KK Duplex & Paper Mills Pvt. Ltd.", AccountNo: "50200070318663", IFSC: "HDFC0004432", BankName: "HDFC Bank Ltd.", Branch: "Bhagwanpur" },
    IRN: "3547d8305e0c3d9dd662f0835dd915468481002f0486cf474dfa58d1a95c2702",
    AckNo: "142517213525727",
    EWayBillNumber: "431560132713",
    EWayBillDate: "25-Apr-2025",
    PlaceOfDelivery: "DELHI",
    FSC: { Code: "PBN-COC-080348", Claim: "FSC RECYCLED 100%" }
  };

  const [reportData] = useState(defaultReportData);

  const handlePrintAll = () => {
    const copyTypes = ["ORIGINAL", "DUPLICATE", "TRIPLICATE"];
    const allContent = copyTypes
      .map((copy) => {
        const element = document.getElementById(`invoiceReport-${copy}`);
        return element ? element.innerHTML : "";
      })
      .join('<div style="page-break-after: always;"></div>');

    const newWindow = window.open("", "_blank", "width=900,height=700");

    if (!newWindow) {
      alert("Please allow pop-ups for this website to print the report.");
      return;
    }

    newWindow.document.write(`
      <html>
        <head>
          <title>Invoice Report</title>
          <style>
            body { font-family: Arial, sans-serif; font-size: 9px; margin: 0; padding: 0; }
            table { border-collapse: collapse; width: 100%; table-layout: fixed; }
            th, td { border: 1px solid #000; padding: 5px; text-align: left; }
            .invoice-page {
              width: 210mm;
              min-height: 297mm;
              margin: 0 auto;
              padding: 10mm 15mm;
              box-sizing: border-box;
            }
          </style>
        </head>
        <body>
          ${allContent}
        </body>
      </html>
    `);
    newWindow.document.close();
    newWindow.focus();
    newWindow.print();
    newWindow.close();
  };

  const renderInvoiceCopy = (copyType) => {
    const { Summary, Header, Buyer, Consignee, Items, Transport, Bank, EWayBillNumber, EWayBillDate, PlaceOfDelivery, FSC, TotalReels, TotalWeight, TotalValue, IRN, AckNo } = reportData;
    
    return (
      <div
        className="invoice-page"
        style={{
          width: "210mm",
          minHeight: "297mm",
          margin: "0 auto",
          padding: "10mm 15mm",
          boxSizing: "border-box",
          border: "1px solid #ccc",
          pageBreakAfter: "always",
          fontFamily: "Arial, sans-serif",
          fontSize: "9px",
        }}
      >
        {/* Header Section */}
        <div style={{ marginBottom: "5px", borderBottom: "2px solid #000" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "5px" }}>
            <div style={{ textAlign: "left" }}>
              <img src="/path/to/your/fsc-logo.png" alt="FSC Logo" style={{ width: "80px", marginBottom: "5px" }} />
              <p style={{ margin: 0, fontSize: "10px", whiteSpace: "nowrap" }}>
                www.fsc.org<br/>
                FSC® C210691<br/>
                The mark of responsible forestry
              </p>
            </div>
            <div style={{ textAlign: "center", flexGrow: 1 }}>
              <h3 style={{ margin: "0", whiteSpace: "nowrap" }}>KK Duplex & Paper Mills Private Limited</h3>
              <div style={{ whiteSpace: "nowrap" }}>8.5TH KM, JANSATH RD, PIN:251001</div>
              <div style={{ whiteSpace: "nowrap" }}>UTTAR PRADESH, INDIA | TEL: 9818622294</div>
              <div style={{ whiteSpace: "nowrap" }}>GSTIN: 09AABCR1065J1ZC</div>
            </div>
            <div style={{ textAlign: "right", whiteSpace: "nowrap" }}>
              <h4 style={{ margin: "0" }}>{copyType}</h4>
            </div>
          </div>
        </div>
        <div style={{ textAlign: "center", marginBottom: "5px", borderBottom: "2px solid #000", paddingBottom: "5px" }}>
          <h2 style={{ margin: "0" }}>Tax Invoice</h2>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "5px", border: "1px solid #000" }}>
          <div style={{ width: "35%", borderRight: "1px solid #000", padding: "5px" }}>
            <h4>Buyers Name & Address</h4>
            <p style={{ margin: 0 }}>{Buyer.Name}</p>
            <p style={{ margin: 0 }}>{Buyer.Address}</p>
            <p style={{ margin: 0 }}>GSTIN: {Buyer.GSTIN}</p>
            <p style={{ margin: 0 }}>
              State: {Buyer.State} ({Buyer.Code})
            </p>
          </div>
          <div style={{ width: "35%", borderRight: "1px solid #000", padding: "5px" }}>
            <h4>Consignee Name & Address</h4>
            <p style={{ margin: 0 }}>{Consignee.Name}</p>
            <p style={{ margin: 0 }}>{Consignee.Address}</p>
            <p style={{ margin: 0 }}>GSTIN: {Consignee.GSTIN}</p>
            <p style={{ margin: 0 }}>
              State: {Consignee.State} ({Consignee.Code})
            </p>
          </div>
          <div style={{ width: "30%", padding: "5px" }}>
            <p style={{ margin: "0" }}>
              <strong>Invoice No</strong>: {Header.InvoiceNo}
            </p>
            <p style={{ margin: "0" }}>
              <strong>Invoice Date</strong>: {Header.InvoiceDate}
            </p>
            <p style={{ margin: "0" }}>
              <strong>E-Way Bill Number</strong>: {EWayBillNumber}
            </p>
            <p style={{ margin: "0" }}>
              <strong>E-Way Bill Date</strong>: {EWayBillDate}
            </p>
            <p style={{ margin: "0" }}>
              <strong>Place of Delivery</strong>: {PlaceOfDelivery}
            </p>
            <div style={{ textAlign: "center", marginTop: "10px", border: "1px solid #000", padding: "5px" }}>
              <img src="/path/to/your/fsc-logo.png" alt="FSC Logo" style={{ width: "60px", marginBottom: "5px" }} />
              <p style={{ margin: "0", fontSize: "8px" }}>
                www.fsc.org<br/>
                FSC® C210691<br/>
                The mark of<br/>
                responsible forestry
              </p>
            </div>
          </div>
        </div>

        <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "5px", fontSize: "9px", tableLayout: "fixed" }}>
          <thead>
            <tr>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "5%" }}>S.No</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "12%" }}>Quality</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "5%" }}>GSM</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "12%" }}>Size</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "10%" }}>HSN</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "12%" }}>Order No</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "6%" }}>Qty</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "6%" }}>UoM</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "10%" }}>Weight</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "10%" }}>Unit Price</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "12%" }}>Total Value</th>
            </tr>
          </thead>
          <tbody>
            {Items.map((row, idx) => (
              <tr key={idx}>
                <td style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap" }}>{idx + 1}</td>
                <td style={{ border: "1px solid #000", padding: "5px", whiteSpace: "nowrap" }}>{row.quality}</td>
                <td style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap" }}>{row.gsm}</td>
                <td style={{ border: "1px solid #000", padding: "5px", whiteSpace: "nowrap" }}>{row.size}</td>
                <td style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap" }}>{row.hsn}</td>
                <td style={{ border: "1px solid #000", padding: "5px", whiteSpace: "nowrap" }}>{row.orderNo}</td>
                <td style={{ border: "1px solid #000", padding: "5px", textAlign: "right", whiteSpace: "nowrap" }}>{row.qty}</td>
                <td style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap" }}>{row.uom}</td>
                <td style={{ border: "1px solid #000", padding: "5px", textAlign: "right", whiteSpace: "nowrap" }}>{row.totalWeight}</td>
                <td style={{ border: "1px solid #000", padding: "5px", textAlign: "right", whiteSpace: "nowrap" }}>{row.unitPrice}</td>
                <td style={{ border: "1px solid #000", padding: "5px", textAlign: "right", whiteSpace: "nowrap" }}>{row.totalValue}</td>
              </tr>
            ))}
            <tr>
              <td colSpan="6" style={{ border: "1px solid #000", padding: "5px", textAlign: "right", fontWeight: "bold" }}>TOTAL</td>
              <td style={{ border: "1px solid #000", padding: "5px", textAlign: "right", fontWeight: "bold" }}>{TotalReels}</td>
              <td style={{ border: "1px solid #000", padding: "5px", textAlign: "right", fontWeight: "bold" }}>{TotalWeight}</td>
              <td style={{ border: "1px solid #000", padding: "5px", whiteSpace: "nowrap" }}></td>
              <td style={{ border: "1px solid #000", padding: "5px", whiteSpace: "nowrap" }}></td>
              <td style={{ border: "1px solid #000", padding: "5px", textAlign: "right", fontWeight: "bold" }}>{TotalValue}</td>
            </tr>
          </tbody>
        </table>

        {/* New Sections */}
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "5px", border: "1px solid #000" }}>
          <div style={{ width: "50%", padding: "5px", borderRight: "1px solid #000" }}>
            <p style={{ margin: "0" }}>
              <strong>Transporter Name</strong>: {Transport.Name}
            </p>
            <p style={{ margin: "0" }}>
              <strong>Shipment Mode</strong>: {Transport.ShipmentMode}
            </p>
            <p style={{ margin: "0" }}>
              <strong>Vehicle No</strong>: {Transport.VehicleNo}
            </p>
            <p style={{ margin: "0" }}>
              <strong>LR No</strong>: {Transport.LRNo}
            </p>
            <p style={{ margin: "0" }}>
              <strong>Terms of Payment</strong>: {Transport.TermsOfPayment}
            </p>
            <p style={{ margin: "0" }}>
              <strong>Due Date</strong>: {Transport.DueDate}
            </p>
          </div>
          <div style={{ width: "50%", padding: "5px" }}>
            <p style={{ margin: "0", display: "flex", justifyContent: "space-between" }}>
              <span>Discount Value</span><span>-</span>
            </p>
            <p style={{ margin: "0", display: "flex", justifyContent: "space-between" }}>
              <span>Freight</span><span>{Summary.Freight?.toFixed(2)}</span>
            </p>
            <p style={{ margin: "0", display: "flex", justifyContent: "space-between" }}>
              <span>Insurance @ 0.02%</span><span>{Summary.Insurance?.toFixed(2)}</span>
            </p>
            <p style={{ margin: "0", display: "flex", justifyContent: "space-between" }}>
              <span>Assessable Value</span><span>{Summary.AssessableValue?.toFixed(2)}</span>
            </p>
            <p style={{ margin: "0", display: "flex", justifyContent: "space-between" }}>
              <span>IGST @ 12.00 %</span><span>{Summary.TaxAmount?.toFixed(2)}</span>
            </p>
            <p style={{ margin: "0", display: "flex", justifyContent: "space-between" }}>
              <span>Round Off</span><span>{Summary.RoundOff?.toFixed(2)}</span>
            </p>
            <p style={{ margin: "0", display: "flex", justifyContent: "space-between", borderTop: "1px solid #000", paddingTop: "5px" }}>
              <strong>Invoice Value</strong><strong>{Summary.NetAmount?.toFixed(2)}</strong>
            </p>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "5px", border: "1px solid #000" }}>
          <div style={{ width: "70%", padding: "5px", borderRight: "1px solid #000" }}>
            <p style={{ margin: "0" }}>
              <strong>Amount In Words:</strong> {Summary.AmountInWords}
            </p>
          </div>
          <div style={{ width: "30%", padding: "5px" }}>
            <p style={{ margin: "0", display: "flex", justifyContent: "space-between" }}>
              <span><strong>Net Amount Receivable</strong></span><span>{Summary.NetAmount?.toFixed(2)}</span>
            </p>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", border: "1px solid #000" }}>
          <div style={{ width: "50%", padding: "5px", borderRight: "1px solid #000" }}>
            <p style={{ margin: "0" }}>
              <strong>Bank Details</strong>
            </p>
            <p style={{ margin: "0" }}>
              <strong>Name</strong>: {Bank.Name}
            </p>
            <p style={{ margin: "0" }}>
              <strong>A/C No</strong>: {Bank.AccountNo}
            </p>
            <p style={{ margin: "0" }}>
              <strong>IFSC</strong>: {Bank.IFSC}
            </p>
            <p style={{ margin: "0" }}>
              <strong>Bank</strong>: {Bank.BankName}
            </p>
            <p style={{ margin: "0" }}>
              <strong>Branch</strong>: {Bank.Branch}
            </p>
          </div>
          <div style={{ width: "50%", padding: "5px" }}>
            <p style={{ margin: "0" }}>
              <strong>FSC-COC Code</strong>: {FSC.Code}
            </p>
            <p style={{ margin: "0" }}>
              <strong>FSC CLAIM</strong>: {FSC.Claim}
            </p>
            <p style={{ margin: "5px 0 0", fontSize: "8px" }}>
              Note: Only the products that are identified as such on this document are FSC certified.
            </p>
          </div>
        </div>
        
        {/* Footer section added based on the provided image */}
        <div style={{ border: "1px solid #000", padding: "5px", display: "flex", alignItems: "flex-start", marginTop: "5px" }}>
            <div style={{ width: "100px", flexShrink: 0, marginRight: "10px" }}>
                {/* Placeholder for the QR code image */}
                

[Image of a QR Code]

            </div>
            <div style={{ flexGrow: 1 }}>
                <p style={{ margin: "0" }}><strong>Ack No</strong>: {AckNo}</p>
                <p style={{ margin: "0" }}><strong>IRN</strong>: {IRN}</p>
                <div style={{ marginTop: "10px", textAlign: "right" }}>
                    <p style={{ margin: "0" }}>For KK Duplex & Paper Mills Private Limited</p>
                    <p style={{ margin: "20px 0 0" }}>Authorized Signatories</p>
                </div>
            </div>
        </div>
        <div style={{ border: "1px solid #000", borderTop: "none", padding: "5px", textAlign: "left", fontSize: "8px" }}>
            <p style={{ margin: "0" }}>Certified that the particulars given above are true and correct and the amount indicated represents the price actually charged and that there is no flow of additional consideration directly or indirectly from the buyer.</p>
        </div>
      </div>
    );
  };

  return (
    <div>
      <h1 style={{ textAlign: "center" }}>Invoice Preview</h1>
      <div style={{ textAlign: "center", margin: "20px 0" }}>
        <button
          onClick={handlePrintAll}
          style={{
            padding: "10px 20px",
            cursor: "pointer",
            border: "none",
            background: "#1976d2",
            color: "#fff",
            borderRadius: "4px",
            fontSize: "14px",
          }}
        >
          Print All Copies
        </button>
      </div>
      
      {["ORIGINAL", "DUPLICATE", "TRIPLICATE"].map((copy) => (
        <div key={copy} id={`invoiceReport-${copy}`}>
          {renderInvoiceCopy(copy)}
        </div>
      ))}
    </div>
  );
};

export default InvoiceReport;